export default "__VITE_PUBLIC_ASSET__4e4a2cbc__"